<template>
  <div>
    <div>
      <div class="bb-dashboard">
        <h2 class="bb-page-title">Finance</h2>
        <div class="bb-dashboard__select">
          <custom-select
            :list="dateRangeList"
            @setValue="setDateRange"
            :default-val="dateRangeList[0]"
            fontSize="12"/>
        </div>
      </div>
      <div class="bb-dashboard">
        <ChartBalanceOnAllAccounts class="bb-dashboard__chart"
                                   :data="dataChart.allAccounts"
                                   :total="toDayTotal.allAccounts"/>
        <ChartBalanceOfClients class="bb-dashboard__chart"
                               :data="dataChart.clients"
                               :total="toDayTotal.clients"/>
      </div>
      <div class="bb-dashboard">
        <ChartVat class="bb-dashboard__chart"
                  :data="dataChart.vat"
                  :total="toDayTotal.vat"/>
        <ChartBalanceOfPartners class="bb-dashboard__chart"
                                :data="dataChart.partners"
                                :total="toDayTotal.partners"/>
      </div>
      <div class="bb-dashboard">
        <ChartNetProfit class="bb-dashboard__chart"
                        :data="dataChart.profit"
                        :total="toDayTotal.profit"/>
      </div>
    </div>
  </div>
</template>

<script>
import ChartBalanceOnAllAccounts from '@/components/Finance/Dashboard/BalanceOnAllAccounts/ChartBalanceOnAllAccounts'
import ChartBalanceOfClients from '@/components/Finance/Dashboard/BalanceOfClients/ChartBalanceOfClients'
import ChartBalanceOfPartners from '@/components/Finance/Dashboard/BalanceOfPartners/ChartBalanceOfPartners'
import ChartVat from '@/components/Finance/Dashboard/Vat/ChartVat'
import ChartNetProfit from '@/components/Finance/Dashboard/NetProfit/ChartNetProfit'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import DashboardApi from '@/api/Dashboard/api'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'Dashboard',
  components: {
    ChartBalanceOnAllAccounts,
    ChartBalanceOfClients,
    ChartBalanceOfPartners,
    ChartVat,
    ChartNetProfit,
    CustomSelect,
    LoaderFly
  },
  data () {
    return {
      loaderRun: false,
      toDayTotal: {
        allAccounts: 0,
        clients: 0,
        partners: 0,
        vats: 0,
        profit: 0
      },
      dataChart: {
        allAccounts: [],
        clients: [],
        partners: [],
        vat: [],
        profit: []
      },
      dateRangeList: [
        {
          name: 'Last 7 days',
          id: 1
        },
        {
          name: 'Current month',
          id: 2
        },
        {
          name: 'Last month',
          id: 3
        },
        {
          name: 'Last 3 months',
          id: 4
        },
        {
          name: 'Last 6 months',
          id: 5
        },
        {
          name: 'Last 12 months',
          id: 6
        }
      ],
      dateRange: '',
      counter: 'days'
    }
  },
  computed: {
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    activeCompany () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    setDateRange (item) {
      const id = item.id
      this.counter = 'days'
      let start = moment() // .add(1, 'days')
      let end = moment() // .add(1, 'days')
      switch (id) {
      case 1:
        start.subtract(6, 'days')
        break
      case 2:
        start.startOf('month')
        break
      case 3:
        start.subtract(1, 'month')
        start.startOf('month')
        end.subtract(1, 'month')
        end.endOf('month')
        break
      case 4:
        start.subtract(3, 'month')
        start.startOf('month')
        end.subtract(1, 'month')
        end.endOf('month')
        this.counter = 'months'
        break
      case 5:
        start.subtract(6, 'month')
        start.startOf('month')
        end.subtract(1, 'month')
        end.endOf('month')
        this.counter = 'months'
        break
      case 6:
        start.startOf('year')
        this.counter = 'months'
        break
      }
      this.dateRange = `${start.format('YYYY-MM-DD')};;${end.format('YYYY-MM-DD')}`
      this.getDashboard(this.dateRange, {end, start}, this.counter)
    },
    getDataChart (start, typeCount, columns, resp) {
      this.clearDataChart()
      for (let i = 0; i < columns; i++) {
        const label = moment(start).add(i, typeCount)
        let formattedLabel = label.format('DD')
        let dateChart = label.format('YYYY-MM-DD')
        if (typeCount === 'months') {
          formattedLabel = label.format('MMM')
          dateChart = label.endOf('month').format('MM')
          const findDate = _.find(resp, item => {
            return item.date.slice(5, 7) === dateChart
          }) || {}
          this.setDataChart(findDate, formattedLabel)
        } else {
          const findDate = _.find(resp, {date: dateChart}) || {}
          this.setDataChart(findDate, formattedLabel)
        }
      }
    },
    setDataChart (data, label) {
      _.forEach(this.dataChart, (item, index) => {
        let value = _.get(data, index, 0)
        if (index === 'vat' || index === 'profit') {
          value = 0
        }
        this.dataChart[index].push([label, value])
      })
    },
    clearDataChart () {
      _.forEach(this.dataChart, (item, index) => {
        this.dataChart[index] = []
      })
    },
    getDashboard (date, {end, start}, counter) {
      DashboardApi.getDashboard(date)
        .then((resp) => {
          const count = end.diff(start, counter) + 1
          const respWithDate = resp.data.map(item => {
            item.date = item._id.day
            return item
          })
          this.getDataChart(start, counter, count, respWithDate)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getTodayDashboard () {
      DashboardApi.getDashboardToday()
        .then((resp) => {
          _.forEach(this.toDayTotal, (item, index) => {
            let value = _.get(resp.data, index, 0)
            _.set(this.toDayTotal, index, value)
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  watch: {
    activeCompany (oldVal) {
      if (oldVal) {
        const [startDate, endDate] = this.dateRange.split(';;')
        const start = moment(startDate)
        const end = moment(endDate)
        this.getDashboard(this.dateRange, {end, start}, this.counter)
      }
    }
  },
  beforeMount () {
    this.getTodayDashboard()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-dashboard {
  @include global-font;
  display: flex;
  margin-right: -25px;

  &__chart {
    width: 100%;
    margin: 25px 25px 0 0;
  }

  &__select {
    margin-right: 25px;
    margin-left: auto;
    width: 163px;
    height: 42px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Finance/Dashboard/Dashboard.vue